/* Go Now — founder video card: play-knop start video, native controls daarna; max één video tegelijk. */
(function () {
  if (window.__gnVidcardInit) return;
  window.__gnVidcardInit = true;

  function pauseOthers(current) {
    document.querySelectorAll('[data-gn-vidcard] video').forEach(function (v) {
      if (v !== current && !v.paused) v.pause();
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.gn-vidcard__play');
    if (!btn) return;
    var card = btn.closest('[data-gn-vidcard]');
    var video = card && card.querySelector('video');
    if (!video) return;
    pauseOthers(video);
    video.setAttribute('controls', 'controls');
    video.play();
  });

  document.addEventListener(
    'play',
    function (e) {
      var card = e.target.closest && e.target.closest('[data-gn-vidcard]');
      if (!card) return;
      card.classList.add('is-playing');
      pauseOthers(e.target);
    },
    true
  );

  document.addEventListener(
    'pause',
    function (e) {
      var card = e.target.closest && e.target.closest('[data-gn-vidcard]');
      if (card) card.classList.remove('is-playing');
    },
    true
  );
})();
